export const excludedCapsMock = []; //Como

export const setExcludedCapsMock = function() {
  if (!window.excluded.length) {
    window.excluded = excludedCapsMock;
  }
}


// WEBPACK FOOTER //
// ./src/modules/mocks/excludedCaps.js